import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Icon24 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Button from 'builder/components/Button'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100vh;
  padding: 36px 53px 0 0;

  border-radius: 24px;
  position: relative;
  overflow: hidden;

  ${Media.Phone`
    padding: 20px 20px 0;
    height: calc(100vh - 90px);
  `};

  ${Media.AboveTablet`
    padding: 36px 53px 0;
    background-color: ${Colors.Blue10};
    width: 544px;
    height: 560px;
    gap: ${Spacing.S};
  `};
`

export const Title = styled.p`
  ${Typography.L};
  ${FontWeights.Medium};
  color: ${Colors.Blue80};
  width: 100%;
  text-align: center;

  ${Media.AboveTablet`
    ${Typography.Subhead};
  `};
`

export const ListItemText = styled.p`
  ${Typography.Body};
  color: ${Colors.Blue80};

  & > span {
    ${FontWeights.DemiBold};
  }

  ${Media.AboveTablet`
    ${Typography.Caption};
  `};
`

export const ImageContainer = styled.div`
  position: absolute;
  bottom: 160px;
  left: 20px;
  right: 20px;
  display: flex;
  justify-content: center;

  ${Media.Phone`
    position: unset;
  `};

  ${Media.AboveTablet`
    bottom: -20px;
  `};
`

export const Image = styled.img`
  width: 100%;
  max-width: 675px;
`

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  ${Media.AboveTablet`
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(2, 1fr);
    gap: ${Spacing.XS};
  `};
`

export const ListItemWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`

export const ListItemIcon = styled(Icon24.Tick)`
  width: 20px;
  height: 20px;
  min-width: 20px;
  color: ${Colors.Blue40};
`

export const GetStartedButton = styled(Button)`
  width: 100%;
  position: absolute;
  right: 53px;
  bottom: 120px;

  ${Media.Phone`
    width: unset;
    right: 20px;
    left: 20px;
    bottom: 80px;
  `};
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;

  ${Media.AbovePhone`
    flex-direction: column;
    align-items: center;
  `};
`
